
<template>
    <div>
        <dicionario-component></dicionario-component>
    </div>
</template>
<script>
import DicionarioComponent from '../../components/Painel/Dicionario/DicionarioComponent.vue';

export default {
    components: {
        DicionarioComponent
    }
}
</script>